import React from 'react';
import className from 'classnames';
import moment from 'moment';
import axios from 'axios';

import {
  canEdit
} from '../lib/policies';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import TableHeader from './TableHeader';

const PolicyList = ({
  policies = []
}) => {
  const updateVersion = (id) => {
    if(confirm('Are you sure to update policy version and force all users to revalidate?')) {
      requestCallback(axios.put(`/${gon.currentProvider}/api/policies/${id}`, {
        authenticity_token: CSRF_TOKEN,
      }))
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Policy</h2>
        </div>
      </div>
      <div
        className={className('Table', {
          'Table--trust-parameters': true,
        })} style={{gridTemplateColumns: 'max-content 1fr max-content max-content'}}
      >
        {(() => {
        const columnHeaders = [
          {
            label: 'ID'
          },
          {
            label: 'Title'
          },
          {
            label: 'Updated At'
          },
          {
            label: 'Manage'
          }
        ]

        return (
          <div className='Table__row'>
            {columnHeaders.map((header, key) => (
              <TableHeader
                key={key}
                header={header}
              />
            ))}
          </div>
          )
        })()}
        {policies.map((policy) => (
          <div
            className='Table__row'
            key={policy.id}
          >
            <div className='Table__col'>{policy.id}</div>
            <div className='Table__col'>{policy.title}</div>
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: policy.updatedAt !== null ?
                    moment(policy.updatedAt).format('YYYY-MM-DD HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>
              <div className='Table__controls'>
                { true &&
                  <button type='button' className='Button Button--transparent Button--block' onClick={() => updateVersion(policy.id)}>
                    <span className='Badge Badge--block'>Update Version</span>
                  </button>
                }
              </div>
            </div>

          </div>

        ))}
      </div>
    </React.Fragment>
  )
}

export default PolicyList
